import degraftPhoto from "../assets/Degraft.png";
import sidPhoto from "../assets/Sid.png";
import cletusPhoto from "../assets/Cletus.png";

const teamMembers = [
  {
    id: "degraft",
    role: "CEO, FOUNDER",
    name: "Degraft Osei",
    description:
      "Operations-led founder with 10+ years leading procurement, operations, and sustainability for luxury hotels, building infrastructure and processes that scale globally and outperform peers.",
    email: "degraft@luupli.com",
    linkedIn: "https://linkedin.com/in/degraft-osei",
    image: degraftPhoto,
    roleColor: "#0D9488",
  },
  {
    id: "sid",
    role: "CO-FOUNDER & CHIEF\nPEOPLE & SCALE OFFICER",
    name: "Sid Pednekar",
    description:
      "People and scale leader with 15+ years at Tiktok, Zalando, Symphony, and Groupon, designing high-performance teams and organizational systems that set industry benchmarks.",
    email: "sid@luupli.com",
    linkedIn: "https://linkedin.com/in/sid-pednekar",
    image: sidPhoto,
    roleColor: "#0D9488",
  },
  {
    id: "cletus",
    role: "CO-FOUNDER & CHIEF\nPRODUCT OFFICER",
    name: "Cletus Kwame",
    description:
      "Product and platform leader with 10+ years building and scaling technology systems for fast-growing tech companies, delivering speed, usability, and enterprise-grade reliability.",
    email: "cletus@luupli.com",
    linkedIn: "https://linkedin.com/in/cletus-kwame",
    image: cletusPhoto,
    roleColor: "#0D9488",
  },
];

const MailIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const TeamSection = () => {
  return (
    <section
      id="team"
      className="bg-white py-16 md:py-20 lg:py-24 xl:py-28 2xl:py-32 overflow-hidden"
    >
      <div className="max-w-[1520px] mx-auto px-4 md:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl lg:text-[42px] lg:leading-tight xl:text-[48px] font-bold text-[#0B0D0B]">
          Our Team
        </h2>

        <div className="mt-10 md:mt-14 lg:mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {teamMembers.map((member) => (
            <article
              key={member.id}
              className="bg-white rounded-[20px] overflow-hidden"
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-full aspect-[4/3] object-cover object-top"
              />

              <div className="px-5 pt-8 pb-6 lg:px-6 lg:pt-10 lg:pb-8">
                <div className="flex items-start justify-between gap-3">
                  <p
                    className="text-[11px] lg:text-xs font-bold uppercase tracking-wider leading-tight whitespace-pre-line"
                    style={{ color: member.roleColor }}
                  >
                    {member.role}
                  </p>
                  <div className="flex gap-2 shrink-0 text-[#0B0D0B]">
                    <a
                      href={`mailto:${member.email}`}
                      className="hover:opacity-60 transition-opacity"
                      aria-label={`Email ${member.name}`}
                    >
                      <MailIcon />
                    </a>
                    <a
                      href={member.linkedIn}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:opacity-60 transition-opacity"
                      aria-label={`${member.name} on LinkedIn`}
                    >
                      <LinkedInIcon />
                    </a>
                  </div>
                </div>

                <h3 className="mt-2 text-xl lg:text-2xl font-bold text-[#0B0D0B]">
                  {member.name}
                </h3>

                <p className="mt-3 text-sm lg:text-[15px] leading-relaxed text-[#0B0D0B]">
                  {member.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
